import React from 'react';
import { Typography } from '../Typography';
import { ClickAwayListener } from '../ClickAwayListener';
import clsx from 'clsx';
import useStyles from './styles';
import { useTheme } from 'theming';
const FloatCard = ({ id, options, customClassName, setOpen }) => {
    const theme = useTheme();
    const classes = useStyles({ theme });
    const containerStyles = clsx({
        [classes.container]: true,
        [customClassName]: Boolean(customClassName)
    });
    return (React.createElement(ClickAwayListener, { onClickAway: () => setOpen(false) },
        React.createElement("div", { id: id, className: containerStyles }, options.map((item, index) => {
            return (React.createElement("div", { key: index, className: classes.item, onClick: item.func },
                React.createElement(Typography, { variant: 'content2' }, item.name)));
        }))));
};
export { FloatCard };
//# sourceMappingURL=FloatCard.js.map